function getStrFromUrl(url,t) {
    let allData = url.split('?');
    let result = '';
    try{
       
        allData.forEach(element => {
            let a = element.split("&");
            for (var i in a){
                    if (a[i].indexOf(t + "=") >= 0) {
                        var n = a[i].split("=");
                        if (null != n[1])
                        result = decodeURI(n[1])
                        break;
                    }
                }
        });
    }catch(e){
        result = '';
    }
   
    return result
}

export function openUrl(url, tabItem = false) {
     if (!url) return
    // try {
    //     if (tabItem) {
    //         wx.switchTab({
    //             url: url
    //         })
    //     } else {
    //         if (/^\/page\//ig.test(url)) {
    //             wx.navigateTo({
    //                 url
    //             })
    //         } else {
    //             let href = encodeURIComponent(url.replace(/^(http:\/\/|https:\/\/|\/\/)((\w|=|\?|\.|\/|&|-)+)/g, 'https://$2'))
    //             wx.navigateTo({
    //                 url: `/page/home/webview/webview?src=${href}`,
    //             })
    //         }
    //     }
    // } catch (e) { 
        window.location.href= url
    //}
}

export function shallowClone(obj) {
    let objArray = Array.isArray(obj) ? [] : {}
    if (obj && typeof obj === 'object') {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key] && typeof obj[key] === 'object') {
                    objArray[key] = shallowClone(obj[key])
                } else {
                    objArray[key] = obj[key]
                }
            }
        }
        return objArray
    }
}
export function getCookie(name){ 
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
 
    if(arr=document.cookie.match(reg))
 
        return unescape(arr[2]); 
    else 
        return null; 
} 
export function addCookie(objName,objValue,objHours){//添加cookie
    
        var str = objName + "=" + objValue;
        if(objHours > 0){//为0时不设定过期时间，浏览器关闭时cookie自动消失
            var date = new Date();
            var ms =24*60*60*1000; //自己设置cookie时间
            date.setTime(date.getTime() + ms); //注意为毫秒值
            str += "; expires=" + date.toGMTString();
        }
        document.cookie = str;
    }
export function changTitle(title){
    var $body = $('body');
        document.title = title;
        
        var $iframe = $('<iframe src="/favicon.ico"></iframe>');
        $iframe.on('load',function() {
        setTimeout(function() {
            $iframe.off('load').remove();
        }, 0);
        }).appendTo($body);
}
export function changeTitle(title) {
    document.title = title
  
    // var iframe = document.createElement('iframe')
    // iframe.style.display = 'none'
    // // 替换成站标favicon路径或者任意存在的较小的图片即可
    // iframe.setAttribute('src', '/favicon.ico')
    // var iframeCallback = function () {
    //     setTimeout(function () {
    //         iframe.removeEventListener('load', iframeCallback)
    //         document.body.removeChild(iframe)
    //     }, 0)
    // }
    // iframe.addEventListener('load', iframeCallback)
    // document.body.appendChild(iframe)
}
// 防抖函数
export function debounce(func, wait, immediate) {
  let timeout;
  
  return function() {
    const context = this;
    const args = arguments;
    
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    
    if (callNow) func.apply(context, args);
  };
}
  
export  {getStrFromUrl}


// WEBPACK FOOTER //
// ./src/util/tool.js